<template>
	<div>
	<i :class="`fa font_lg	${realIcon.iconName} ${realIcon.colorName}`"></i>
	<span v-if="realText" class="margin_l_5"><b>{{realText}}</b></span>
	</div>
</template>
<script>
export default {
	data() {
		return {
			tipContent:''
		};
	},
	mounted() {},
	computed: {
		realIcon() {
			return this.params.color(this.params.data);
		},
		realText() {
			return this.params.text(this.params.data);
		}
	}
};
</script>
